import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('dmaTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      geoSource: '@',
      selectedLists: '<',
      dmaOptions: '<'
    },
    template: require("../templates/dmaTargeting.html"),
    controllerAs: '$dmaTargetingCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.targetingOptions();
      this.targetingSourceOptions = componentHelper.targetingSourceOptions();
    }
});
